import { signal } from "@preact/signals-react"
import { useEffect } from "react"
import { fetchUTGManifest } from "../utils/api"

export const loading = signal(false)
export const error = signal(null)
export const utgs = signal([])

const fetchData = async (config, accessToken) => {

    // short-circuit if we have a pending request, are waiting for parameters or have already received an error
    if (loading.value || !config || !accessToken || error.value) {
        return
    }
    
    try {
        loading.value = true
        const data = await fetchUTGManifest(config, accessToken)
        utgs.value = data.product
    }
    catch(err) {
        error.value = err
    }
    finally {
        loading.value = false
    }  
    
}

export default function useUtgManifest(config, accessToken) {
    useEffect(() => {
        fetchData(config, accessToken)
    }, [config, accessToken])

    return {
        utgs, loading, error
    }
}